import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useSelector, useDispatch } from "react-redux";
import { Logout } from "../../actions/Auth/Auth";
import usercircle from "../../Assets/Images/usercircle.svg";
import settings from "../../Assets/Images/settings.svg";
import logOut from "../../Assets/Images/logOut.svg";
import "../../Assets/Styles/pages/header.scss";

const Profile = ({ setOpenSettings, item = "start", anchor }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isMouseOver, setIsMouseOver] = useState(false);
  const userSliceState = useSelector((state) => state["userSlice"]);
  const dispatch = useDispatch();

  const handleClick = () => {
    // Add a delay before setting the anchorEl to null
    if (anchor.current === anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(anchor.current);
    }
  };
  const handleMouseEnter = () => {
    setIsMouseOver(true);
  };

  const handleMouseLeave = () => {
    setIsMouseOver(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleItemClick = (event) => {
    if (event.target.innerText === "Settings") {
      setOpenSettings(true);
    } else if (event.target.innerText === "Logout") {
      dispatch(Logout());
    }
    handleClose();
  };

  return (
    <Row
      className={`justify-content-${item} text-truncate m-0 p-0 align-items-center flex-nowrap position-relative`}
    >
      <Avatar
        onClick={handleClick}
        className={`${item === "center" ? "size_5rem " : "w_40x40"} p-0 m-1`}
        alt="User Profile"
        src={
          userSliceState.user_Auth.photoURL
            ? userSliceState.user_Auth.photoURL
            : usercircle
        }
      />
      <Menu
        // sx={{ ml: '-3rem', mt: '4rem', p: '0' }}
        className="position-absolute p-0 menuDiv"
        anchorEl={anchorEl}
        open={anchorEl !== null}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div className="w_255 profileMenuDiv text_13 productSans position-relative">
          <div
            className={` ${isMouseOver && "triangle_up_hover"} triangle_up`}
          ></div>
          <MenuItem className=" profileMenu p-0" onClick={handleItemClick}>
            <Row
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              className="d-flex align-items-center position-relative border-bottom  px-1 py-3 line_height_100pc w-100 m-0 p-0"
            >
              <Col
                md={3}
                className="m-0 p-0 d-flex flex-column justify-content-center align-items-center"
              >
                <Avatar
                  className="w_40x40"
                  src={
                    userSliceState.user_Auth.photoURL
                      ? userSliceState.user_Auth.photoURL
                      : usercircle
                  }
                />
              </Col>
              <Col className="m-0 p-0 d-flex flex-column justify-content-center align-items-start">
                <Row className="m-0 p-0 mb-1 text_19 productSansLight">
                  {userSliceState.user_Auth.displayName}
                </Row>
                <Row className="m-0 p-0 text_11">
                  {userSliceState.user_Auth.email}
                </Row>
              </Col>
            </Row>
          </MenuItem>
          <MenuItem className=" profileMenu p-0" onClick={handleItemClick}>
            <Row className="d-flex align-items-center border-bottom px-1 py-3 line_height_100pc w-100 m-0 p-0">
              <Col
                md={3}
                className="m-0 p-0 d-flex flex-column justify-content-center align-items-center"
              >
                <img alt="settings" className="w_21r" src={settings} />
              </Col>
              <Col className="m-0 p-0 d-flex flex-column justify-content-center align-items-start">
                <Row className="m-0 p-0">Settings</Row>
              </Col>
            </Row>
          </MenuItem>
          <MenuItem className=" profileMenu p-0" onClick={handleItemClick}>
            <Row className="d-flex align-items-center px-1 py-3 line_height_100pc w-100 m-0 p-0">
              <Col
                md={3}
                className="m-0 p-0 d-flex flex-column justify-content-center align-items-center"
              >
                <img className="w_21r" src={logOut} alt="Logout" />
              </Col>
              <Col className="m-0 p-0 d-flex flex-column justify-content-center align-items-start">
                <Row className="m-0 p-0">Logout</Row>
              </Col>
            </Row>
          </MenuItem>
        </div>
      </Menu>
    </Row>
  );
};

export default Profile;
